import React from 'react';
import { useNavigate } from 'react-router';

function DataTDs({ sumDs, data, isVacant }) {
    const navigate = useNavigate();
    if (!sumDs) return null;
    const { dataClass, valView, variView, okNgView, indexType, applyToOkNg } = sumDs;
    const onClickDetail = (e, sIdx, dataId) => {
        e.preventDefault();
        navigate(`/home/data/monitoring?sdsId=${sumDs.sumDsId}&sIdx=${sIdx}&dataId=${dataId}`);
    };

    function getDecision(index, data, aton) {
        const atonArr = aton[index];
        const stdValArr = JSON.parse(data.model.stdVal);
        const stdVal = stdValArr[index];
        const className = dataClass[index];
        let decArr = [];
        for (let idx = 0; idx < atonArr.length; idx++) {
            if (atonArr[idx]) {
                const keyName = `data_${index}_${idx}`;
                const differ = data[keyName] - stdVal[idx][0];
                decArr.push(data[keyName] === null ? null : differ >= stdVal[idx][1] && differ <= stdVal[idx][2]);
            }
        }

        if (className === '치수') {
            return decArr.every(el => el === null) ? '-' : decArr.filter(el => el !== null).some(el => el === true) ? 'OK' : 'NG';
        } else {
            return decArr.every(el => el === null) ? '-' : decArr.filter(el => el !== null).every(el => el === true) ? 'OK' : 'NG';
        }
    }
    return (
        <React.Fragment>
            {
                variView.map((innerArr, index) => {
                    const valViewArr = valView[index];
                    const okNgViewVal = okNgView[index];
                    const stdValOuter = data?.model ? JSON.parse(data.model.stdVal)[index] : [];
                    if (valViewArr.filter(el => el === true).length === 0) {
                        return null;
                    } else {
                        return (
                            <React.Fragment key={`${data?.dataId ?? "vacantCell"}_${index}`}>
                                {innerArr.map((hasVari, idx) => {
                                    const stdVal = stdValOuter[idx];
                                    if (valViewArr[idx]) {
                                        return (
                                            <React.Fragment key={`data_${index}_${idx}`}>
                                                <td className={`data_${index}_${idx}`} >
                                                    {
                                                        isVacant ?
                                                            null
                                                            :
                                                            <p>{
                                                                indexType[index][idx] === 'BOOLEAN'
                                                                    ? data[`data_${index}_${idx}`] === null || data[`data_${index}_${idx}`] ? 'OK' : 'NG'
                                                                    : data[`data_${index}_${idx}`]
                                                            }</p>
                                                    }
                                                </td>
                                                {
                                                    hasVari ?
                                                        <td className={`data_${index}_${idx}_gap`}>
                                                            {
                                                                isVacant ?
                                                                    null
                                                                    :
                                                                    <div className='percentageDiv'>
                                                                        <p>{data[`data_${index}_${idx}`] ? Math.round(Math.abs((data[`data_${index}_${idx}`] - stdVal[0]) / stdVal[0]) * 1000) / 10 : 0}</p>
                                                                        <span>%</span>
                                                                    </div>
                                                            }
                                                        </td>
                                                        : null
                                                }
                                            </React.Fragment>
                                        )
                                    }
                                })}
                                {
                                    okNgViewVal ?
                                        <td className={`class${index}_detail`}>
                                            {
                                                isVacant ?
                                                    null
                                                    :
                                                    // <p>{data[`sDecision_${index}`]}</p>
                                                    <p>{getDecision(index, data, applyToOkNg)}</p>
                                            }
                                        </td>
                                        : null

                                }
                                <td className={`class${index}_detail detailCol`}>
                                    {
                                        isVacant ?
                                            null
                                            :
                                            <button onClick={e => onClickDetail(e, index, data[`sId_${index}`])} disabled={!data[`sId_${index}`]}>상세</button>
                                    }
                                </td>
                            </React.Fragment>
                        )
                    }
                })
            }
        </React.Fragment>
    );
}

export default DataTDs;